jQuery(function ($) {
    "use strict";
    var windowLoad = false;
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).outerHeight();
    var $root = $('html, body');

    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });

    $(window).on('load', function () {
        windowLoad = true;
        if ($('.visual-design-noscroll-item').length) {
            $('.visual-design-noscroll-container').isotope({
                itemSelector: '.visual-design-noscroll-item',
                percentPosition: true,
                layoutMode: 'fitRows',
                masonry: {
                    columnWidth: '.visual-design-noscroll-item'
                }
            });
        }
    });
    $(document).ready(function () {
        AOS.init({
            once: true,
            duration: 600,
        });
        var $window = $(window);
        var $body = $('body');
        $(window).on("scroll", function () {
            if ($window.scrollTop() > 50) {
                $body.addClass('sticky-toggle');
            } else {
                $body.removeClass('sticky-toggle');
            }
        });

        setTimeout(function () {
            AOS.init();
        }, 4000);
        if (windowWidth > 768) {

        }


        // $('.menu-footer-2-container a').on('click', function(e) {
        //     e.preventDefault();
        // })

        $(document).on('click', '.wrap-categories a', function (e) {
            e.preventDefault();
            $('.wrap-categories a').removeClass('active');
            $("#loadmorecontainer").html('<div class="loading-indicator"></div>');
            var $el = $(this),
                link = $el.attr('href');
            $("#loadmorecontainer").load(link + " #loadmorecontainer", function () {
                $("#loadmorecontainer").html($(this).find("#loadmorecontainer").html());
            });
            $el.addClass('active');
        });

        $(document).on('click', '.loadmore', function (e) {
            e.preventDefault();
            var $el = $(this),
                link = $el.attr('href');
            if ($el.attr('disabled'))
                return;
            $el.addClass('loading').attr('disabled', true);
            $el.find('span').html('Loading...')
            $("<div>").load(link + " #loadmorecontainer", function () {
                $("#loadmorecontainer").append($(this).find("#loadmorecontainer").html());
                $el.parents('.load-more').removeAttr('disabled').remove();
            });
        });

        $(document).on('mouseover', '#primary-menu li a', function (e) {
            e.preventDefault();
            var url = $(this).attr('data-image')
            if (url) {
                $('.site-header-open-img img').attr('src', url).show()
            }
        });
        $(document).on('mouseout', '#primary-menu li a', function (e) {
            e.preventDefault();
            $('.site-header-open-img img').hide()
        });

        // Navigation
        $(document).on('click', '.nav-toggle', function () {
            $(this).toggleClass('on');
            $('html').toggleClass('nav-on');
        });
        $(document).on('click', '.site-header-open-close', function () {
            $('.nav-toggle').removeClass('on');
            $('html').removeClass('nav-on');
        });



        $('#agreement').on('click', function () {
            // var isDisabled = $('#agreement').is(":checked");
            // console.log('isDisabled', isDisabled)
            $(".site-footer-form-footer button").prop('disabled', !$('#agreement').is(":checked"));
        })
        if ($('body').hasClass('page-template-page-campaign')) {
            var $impactDataItems = $('.impact-data li')
            var impactTimerCount = 0;
            if ($impactDataItems.length) {
                $impactDataItems.eq(0).addClass('active');
                setInterval(function () {
                    impactTimerCount = impactTimerCount + 1;
                    if (impactTimerCount > 2) {
                        impactTimerCount = 0;
                    }
                    $impactDataItems.removeClass('active')
                    $impactDataItems.eq(impactTimerCount).addClass('active')
                }, 3000);
            }
        }

        if ($('body').hasClass('page-template-page-ebook')) {
            $('.services-slider').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                dots: false,
                prevArrow: $(".testi-nav-btn.prev"),
                nextArrow: $(".testi-nav-btn.next"),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            autoplay: true,
                            arrows: true,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplay: true,
                            arrows: true,
                            dots: false,
                        }
                    }
                ]
            });
            $('.play-slider').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                dots: false,
                prevArrow: $(".testi-nav-btn.prev"),
                nextArrow: $(".testi-nav-btn.next"),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            autoplay: true,
                            arrows: true,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplay: true,
                            arrows: true,
                            dots: false,
                        }
                    }
                ]
            });
        }
        if ($('body').hasClass('page-template-page-google-campaign') || $('body').hasClass('page-template-page-industries')) {
            var $impactDataItems = $('.impact-data li')
            var impactTimerCount = 0;
            if ($impactDataItems.length) {
                $impactDataItems.eq(0).addClass('active');
                setInterval(function () {
                    impactTimerCount = impactTimerCount + 1;
                    if (impactTimerCount > 2) {
                        impactTimerCount = 0;
                    }
                    $impactDataItems.removeClass('active')
                    $impactDataItems.eq(impactTimerCount).addClass('active')
                }, 3000);
            }

            var $bannerTextItem = $('.banner-animation li')
            var BannerTextCount = 0;
            if ($bannerTextItem.length) {
                $bannerTextItem.eq(0).addClass('active');
                setInterval(function () {
                    BannerTextCount = BannerTextCount + 1;
                    if (BannerTextCount > $bannerTextItem.length - 1) {
                        BannerTextCount = 0;
                    }
                    $bannerTextItem.removeClass('active')
                    $bannerTextItem.eq(BannerTextCount).addClass('active')
                    var BannerTextItemHeight = $('.banner-animation li.active').height();
                    $(".banner-animation").css("height", BannerTextItemHeight);

                }, 2000);
            }

            $('.testimonials').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                dots: false,
                prevArrow: $(".testi-nav-btn.prev"),
                nextArrow: $(".testi-nav-btn.next"),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            autoplay: true,
                            arrows: true,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplay: true,
                            arrows: true,
                            dots: false,
                        }
                    }
                ]
            });
            $('.award').slick({
                slidesToShow: 5.5,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                arrows: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                dots: false,
                speed: 2000,
                autoplaySpeed: 2000,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            autoplay: true,
                            arrows: false,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 2,
                            autoplay: true,
                            arrows: false,
                            dots: false,
                        }
                    }
                ]
            });

            var impactItems = $('.services-impact-stat');
            if (impactItems.length) {
                var i = 1;
                setInterval(function () {
                    impactItems.removeClass('active');
                    impactItems.eq(i).addClass('active');
                    i = i + 1;
                    if (i > (impactItems.length - 1)) {
                        i = 0;
                    }
                }, 3000);
            }
            $('.faq-item .faq-head').on('click', function () {
                $(this).toggleClass('active');
                $(this).next().slideToggle('fast');
            })

            $('.impact-client').each(function() {
                $(this).children().first().addClass('active');
            });
            setInterval (function timelineBody() {
                var $slider = $('.impact-client');
                var $current = $slider.find('img.active');

                if(!$current.length) {
                    var $next = $slider.find('img:first');
                } else {
                    var $next = $current.next();
                    $current.removeClass('active');

                }

                if(!$next.length) {
                    $next = $slider.find('img:first');
                }

                $next.addClass('active');
            }, 5000);

            if (windowWidth > 768) {
                var controller = new ScrollMagic.Controller();
                var otherBenifits = $('.careers-ob-benefit');
                var scrollWidth = (otherBenifits.outerWidth() * otherBenifits.length);
                if (windowWidth > 1304) {
                    windowWidth = 1304;
                }
                var tween = TweenMax.fromTo(".careers-ob-benefits-inner", 1, { x: 0, y: 0 }, { x: -Math.abs(windowWidth - scrollWidth), y: 0 });
                var scene = new ScrollMagic.Scene({ triggerElement: ".careers-ob", triggerHook: 0, duration: windowHeight, offset: 100 })
                    .setTween(tween)
                    .setPin(".careers-ob")
                    .addTo(controller);
            }
        }
        if ($('body').hasClass('page-template-page-home') || $('body').hasClass('page-template-page-marketing')) {
            $('.impact-client').each(function() {
                $(this).children().first().addClass('active');
            });
            setInterval (function timelineBody() {
                var $slider = $('.impact-client');
                var $current = $slider.find('img.active');

                if(!$current.length) {
                    var $next = $slider.find('img:first');
                } else {
                    var $next = $current.next();
                    $current.removeClass('active');

                }

                if(!$next.length) {
                    $next = $slider.find('img:first');
                }

                $next.addClass('active');
            }, 5000);
            var $impactDataItems = $('.impact-data li')
            var impactTimerCount = 0;
            if ($impactDataItems.length) {
                $impactDataItems.eq(0).addClass('active');
                setInterval(function () {
                    impactTimerCount = impactTimerCount + 1;
                    if (impactTimerCount > 2) {
                        impactTimerCount = 0;
                    }
                    $impactDataItems.removeClass('active')
                    $impactDataItems.eq(impactTimerCount).addClass('active')
                }, 3000);
            }

            $('.testimonials').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                dots: false,
                prevArrow: $(".testi-nav-btn.prev"),
                nextArrow: $(".testi-nav-btn.next"),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            autoplay: true,
                            arrows: true,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplay: true,
                            arrows: true,
                            dots: false,
                        }
                    }
                ]
            });
            $('.award').slick({
                slidesToShow: 5.5,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                arrows: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                dots: false,
                speed: 2000,
                autoplaySpeed: 2000,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            autoplay: true,
                            arrows: false,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 2,
                            autoplay: true,
                            arrows: false,
                            dots: false,
                        }
                    }
                ]
            });

            $('.home-work-slider').slick({
                arrows: true,
                slidesToShow: 1,
                infinite: true,
                dots: true,
                autoplay: true,
                autoplaySpeed: 2500,
                appendDots: '.dots-container-inner',
                customPaging: function (slick, index) {
                    return '<div class="slick-dot-progress"></div>';
                },
                prevArrow: $(".btn-hw-nav.prev"),
                nextArrow: $(".btn-hw-nav.next")
            });
            // $('.btn-hw-nav').on('click', function() {
            //     // var currentSlide = $('.your-element').slick('slickCurrentSlide');
            //     $('.home-work-slider').slick('slickPrev');
            // });
            // $('.btn-hw-nav.next').on('click', function() {
            //     $('.home-work-slider').slick('slickNext');
            // });


            $('.faq-item .faq-head').on('click', function () {
                $(this).toggleClass('active');
                $(this).next().slideToggle('fast');
            })
        }

        if ($('body').hasClass('page-template-page-industries')) {
            $('.revolution-animated').each(function() {
                $(this).children().first().addClass('active');
            });
            setInterval (function timelineBody() {
                var $slider = $('.revolution-animated');
                var $current = $slider.find('.revolution-animated-item.active');

                if(!$current.length) {
                    var $next = $slider.find('.revolution-animated-item:first');
                } else {
                    var $next = $current.next();
                    $current.removeClass('active');

                }

                if(!$next.length) {
                    $next = $slider.find('.revolution-animated-item:first');
                }

                $next.addClass('active');
            }, 5000);

            $('.expertise-slider').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                dots: false,
                prevArrow: $(".expertise .testi-nav-btn.prev"),
                nextArrow: $(".expertise .testi-nav-btn.next"),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            autoplay: true,
                            arrows: true,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplay: true,
                            arrows: true,
                            dots: false,
                        }
                    }
                ]
            });
         }

        if ($('body').hasClass('page-template-page-careers') || $('body').hasClass('page-template-page-services')) {

            $('.testimonials').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                prevArrow: $(".testi-nav-btn.prev"),
                nextArrow: $(".testi-nav-btn.next")
            });

            var impactItems = $('.services-impact-stat');
            if (impactItems.length) {
                var i = 1;
                setInterval(function () {
                    impactItems.removeClass('active');
                    impactItems.eq(i).addClass('active');
                    i = i + 1;
                    if (i > (impactItems.length - 1)) {
                        i = 0;
                    }
                }, 3000);
            }

        }

        if ($('body').hasClass('single-industry')) {
            $('.faq-item .faq-head').on('click', function () {
                $(this).toggleClass('active');
                $(this).next().slideToggle('fast');
            })
        }

        if ($('body').hasClass('page-template-page-careers')) {
            $('.impact-client').each(function() {
                $(this).children().first().addClass('active');
            });
            setInterval (function timelineBody() {
                var $slider = $('.impact-client');
                var $current = $slider.find('img.active');

                if(!$current.length) {
                    var $next = $slider.find('img:first');
                } else {
                    var $next = $current.next();
                    $current.removeClass('active');

                }

                if(!$next.length) {
                    $next = $slider.find('img:first');
                }

                $next.addClass('active');
            }, 5000);
            var $impactDataItems = $('.impact-data li')
            var impactTimerCount = 0;
            if ($impactDataItems.length) {
                $impactDataItems.eq(0).addClass('active');
                setInterval(function () {
                    impactTimerCount = impactTimerCount + 1;
                    if (impactTimerCount > 2) {
                        impactTimerCount = 0;
                    }
                    $impactDataItems.removeClass('active')
                    $impactDataItems.eq(impactTimerCount).addClass('active')
                }, 3000);
            }

            // $('.testimonials').slick({
            //     slidesToShow: 1,
            //     slidesToScroll: 1,
            //     infinite: false,
            //     prevArrow: $(".testi-nav-btn.prev"),
            //     nextArrow: $(".testi-nav-btn.next")
            // });

            if (windowWidth > 768) {
                var controller = new ScrollMagic.Controller();
                var otherBenifits = $('.careers-ob-benefit');
                var scrollWidth = (otherBenifits.outerWidth() * otherBenifits.length);
                if (windowWidth > 1304) {
                    windowWidth = 1304;
                }
                var tween = TweenMax.fromTo(".careers-ob-benefits-inner", 1, { x: 0, y: 0 }, { x: -Math.abs(windowWidth - scrollWidth), y: 0 });
                var scene = new ScrollMagic.Scene({ triggerElement: ".careers-ob", triggerHook: 0, duration: windowHeight, offset: 100 })
                    .setTween(tween)
                    .setPin(".careers-ob")
                    .addTo(controller);
            }

        }


        if ($('body').hasClass('single-career') || $('body').hasClass('page-template-page-about')) {
            if (windowWidth > 768) {
                var controller = new ScrollMagic.Controller();
                var otherBenifits = $('.nb-proud-item');
                var scrollWidth = (otherBenifits.outerWidth() * otherBenifits.length);
                if (windowWidth > 1304) {
                    windowWidth = 1304;
                }
                var tween = TweenMax.fromTo(".nb-proud-items", 1, { x: 0, y: 0 }, { x: -Math.abs(windowWidth - scrollWidth), y: 0 });
                // var scene = new ScrollMagic.Scene({ triggerElement: ".nb-proud", triggerHook: 0, duration: windowHeight, offset: -(windowWidth * 0.09) })
                var scene = new ScrollMagic.Scene({ triggerElement: ".nb-proud", triggerHook: 0, duration: windowHeight, offset: 0 })
                    .setTween(tween)
                    .setPin(".nb-proud")
                    .addTo(controller);
            }
        }
        if ($('body').hasClass('page-template-page-contact') || $('main').hasClass('gCampaign')) {
            // if(windowWidth > 768) {
            //     var controller = new ScrollMagic.Controller();
            //     var otherBenifits = $('.contact-heart-img');
            //     var scrollWidth = ((otherBenifits.outerWidth() + 24) * otherBenifits.length);
            //     var ww1 = windowWidth;
            //     if(windowWidth > 1920) {
            //         ww1 = 1920;
            //     }
            //     if(scrollWidth < ww1) {
            //         return;
            //     }
            //     var tween = TweenMax.fromTo(".contact-heart-imgs", 1, { x: 0, y: 0 }, { x: -Math.abs(ww1 - scrollWidth), y: 0 });
            //     var scene = new ScrollMagic.Scene({ triggerElement: ".contact-heart", triggerHook:0.7, duration: windowHeight, offset: -30})
            //         .setTween(tween)
            //         // .setPin(".contact-heart")
            //         .addTo(controller);
            // }
            $('.contact-forms-card').on('click', function () {
                var ind = $(this).parent().index();
                $(this).parents('.contact-forms-cards').find('.col').removeClass('active');
                $(this).parent().addClass('active');
                $('.contact-forms-inner').find('.contact-form').removeClass('active').eq(ind).addClass('active')
            });
            $('.gfield_select').addClass('placeholder-shown');
            $('.gfield_select').on('change', function (event) {
                const $this = $(event.currentTarget);
                if ($this.val()) {
                    $this.removeClass("placeholder-shown").addClass("placeholder-hidden");
                } else {
                    $this.addClass("placeholder-shown").removeClass("placeholder-hidden");
                }
            })
        }


        if ($('body').hasClass('single-case-study')) {
            if (windowWidth > 768) {
                var vd = $('.visual-design-row:not(.reverse) .visual-design-item');
                if (vd.length) {
                    var controller = new ScrollMagic.Controller();
                    var scrollWidth = (vd.outerWidth() * vd.length) - windowWidth - 60;
                    var tween = TweenMax.fromTo(".visual-design-row:not(.reverse)", 1, { x: 0, y: 0 }, { x: -scrollWidth, y: 0 });
                    var tween1 = TweenMax.fromTo(".visual-design-row.reverse", 1, { x: 0, y: 0 }, { x: scrollWidth, y: 0 });

                    new ScrollMagic.Scene({ triggerElement: ".visual-design-row:not(.reverse)", triggerHook: 0, duration: (windowHeight + (windowHeight * 0.25)) })
                        .setTween(tween)
                        .addTo(controller);

                    new ScrollMagic.Scene({ triggerElement: ".visual-design-row:not(.reverse)", triggerHook: 0, duration: (windowHeight + (windowHeight * 0.25)) })
                        .setTween(tween1)
                        .addTo(controller);
                }

            }
            $('.key-services-item-inner').on('click', function () {
                $root.animate({
                    scrollTop: $($.attr(this, 'href')).offset().top
                }, 500);
            });

        }





        if (windowWidth > 768) {
            var otherBenifits = $('.pain-points-item');
            if (otherBenifits.length > 3) {
                var controller = new ScrollMagic.Controller();
                var scrollWidth = (otherBenifits.outerWidth() * otherBenifits.length);
                if (windowWidth > 1144) {
                    windowWidth = 1144;
                }
                var tween = TweenMax.fromTo(".pain-points-items", 1, { x: 0, y: 0 }, { x: -Math.abs(windowWidth - scrollWidth), y: 0 });
                var scene = new ScrollMagic.Scene({ triggerElement: ".pain-points", triggerHook: 0, duration: windowHeight, offset: 0 })
                    .setTween(tween)
                    .setPin(".pain-points")
                    .addTo(controller);
            }
        }


        $('.iframe-link').magnificPopup({
            type: 'iframe'
        });


    });

    function iOS() {
        var
            is_ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent),
            is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        return is_ios && is_safari;
    }

    if (iOS()) {
        $('body').addClass('ios')
    }

});
